import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { RecommendationSourceObjectType } from '@udemy-v2/react-recommendations';
import { LimitedAccessRecommendationsSourceObject, LimitedAccessRecommendationsWrapper } from './limited-access-recommendations-wrapper.react-component';
import { LimitedAccessRecommendationsCarousel } from './limited-access-recommendations-carousel.react-component';
export interface UnavailableCourseCategoryProps {
  categoryId?: string;
  subcategoryId?: string;
}
interface UnavailableCourseCategoryRecommendationsWrapperProps extends UnavailableCourseCategoryProps {
  children: React.ReactNode;
}
const useCategorySourceObjects = (categoryId, subcategoryId) => {
  const $ = _c(7);
  let sourceObjects;
  if ($[0] !== categoryId || $[1] !== subcategoryId) {
    sourceObjects = [];
    if (subcategoryId) {
      let t0;
      if ($[3] !== subcategoryId) {
        t0 = {
          id: subcategoryId,
          type: RecommendationSourceObjectType.Subcategory
        };
        $[3] = subcategoryId;
        $[4] = t0;
      } else {
        t0 = $[4];
      }
      sourceObjects.push(t0);
    }
    if (categoryId) {
      let t0;
      if ($[5] !== categoryId) {
        t0 = {
          id: categoryId,
          type: RecommendationSourceObjectType.Category
        };
        $[5] = categoryId;
        $[6] = t0;
      } else {
        t0 = $[6];
      }
      sourceObjects.push(t0);
    }
    $[0] = categoryId;
    $[1] = subcategoryId;
    $[2] = sourceObjects;
  } else {
    sourceObjects = $[2];
  }
  return sourceObjects;
};
export const UnavailableCourseCategoryRecommendationsWrapper = t0 => {
  const $ = _c(3);
  const {
    categoryId,
    subcategoryId,
    children
  } = t0;
  const sourceObjects = useCategorySourceObjects(categoryId, subcategoryId);
  let t1;
  if ($[0] !== children || $[1] !== sourceObjects) {
    t1 = <LimitedAccessRecommendationsWrapper sourceObjects={sourceObjects} contextId="disabled_course_cat">{children}</LimitedAccessRecommendationsWrapper>;
    $[0] = children;
    $[1] = sourceObjects;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const UnavailableCourseCategoryCarousel = t0 => {
  const $ = _c(4);
  const {
    categoryId,
    subcategoryId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LimitedAccessRecommendationsCarousel />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== categoryId || $[2] !== subcategoryId) {
    t2 = <UnavailableCourseCategoryRecommendationsWrapper categoryId={categoryId} subcategoryId={subcategoryId}>{t1}</UnavailableCourseCategoryRecommendationsWrapper>;
    $[1] = categoryId;
    $[2] = subcategoryId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};